exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swal2-content {\n    font-size: 16px;\n    font-weight: 300;\n}\nbutton.swal2-styled {\n    padding: 5px 15px;\n}\n", ""]);

// exports
